import paths from "./config";
import { apiHeaderOptions } from "./apiHeaderOptions";

const getAssetAudits = async (id: string, pageNumber: number, pageSize: number) => {
  const url = paths.auditAssets(id, pageNumber, pageSize);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

const getAssetAuditDetails = async (assetId: string | undefined, auditId: string | null) => {
  const url = paths.assetAuditDetails(assetId, auditId);
  const requestOptions = apiHeaderOptions();
  return fetch(url, requestOptions);
};

const assetAuditService = {
  getAssetAudits,
  getAssetAuditDetails
};

export default assetAuditService;
